import React from 'react';
import { Card, Typography, Box, CircularProgress } from '@mui/material';
import { useDashboardData } from '../../../contexts/DashboardDataContext';
import { useDashboardContext } from '../../Dashboard';

const ServiceQueueWidget = () => {
    const { serviceQueue, fetchServiceQueue } = useDashboardData();
    const { currentZone } = useDashboardContext();
    const { loading, data, error } = serviceQueue;

    // Debug logging
    React.useEffect(() => {
        console.log('ServiceQueue Widget Data:', data);
    }, [data]);

    // No loading state if we have data
    if (!data) {
        if (loading) {
            return (
                <Card
                    sx={{
                        padding: 2,
                        backgroundColor: '#1e1e1e',
                        color: '#fff',
                        borderRadius: '8px',
                        textAlign: 'center',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        width: '220px',
                        height: '130px',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                </Card>
            );
        }

        if (error) {
            return (
                <Card
                    sx={{
                        padding: 2,
                        backgroundColor: '#1e1e1e',
                        color: '#fff',
                        borderRadius: '8px',
                        textAlign: 'center',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        width: '220px',
                        height: '130px',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }}
                >
                    <Typography variant="h6">Service Queue</Typography>
                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                        {error || "No data available"}
                    </Typography>
                    <button onClick={fetchServiceQueue} style={{ marginTop: 8, fontSize: '0.8rem' }}>
                        Refresh
                    </button>
                </Card>
            );
        }
    }

    // Sjekk direkte på totalQueue fra data-objektet
    const totalQueue = data?.totalQueue ?? 0;

    return (
        <Card
            sx={{
                padding: 2,
                backgroundColor: '#1e1e1e',
                color: '#fff',
                borderRadius: '8px',
                textAlign: 'center',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                width: '220px',
                height: '130px',
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }}
        >
            <Typography variant="h6" gutterBottom>Service Queue</Typography>
            <Typography variant="h2" color="#4fc3f7" sx={{ fontWeight: 'bold' }}>
                {totalQueue}
            </Typography>
        </Card>
    );
};

export default ServiceQueueWidget;
